module.exports = __webpack_public_path__ + "static/media/twitterBlack.d2e06d37.svg";